import React from "react";
import { Button } from "../../ui/button";

export default function NoCompany() {
  const reloadPage = () => {
    if (window && typeof window !== "undefined") {
      window.parent.postMessage("RELOAD_WEBSITE", "*");
    }
  };
  return (
    <>
      <div className="border border-border rounded-[14px] overflow-hidden bg-background p-3">
        Unable to load the prospect's work experience. Please reload the page to try again.
        <div className="mt-3">
          <Button onClick={reloadPage}>Reload</Button>
        </div>
      </div>
    </>
  );
}
